export default __webpack_public_path__ + "static/media/login-btn.19abec27.svg";